import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {FtsComponent} from './fts/fts.component';
import {HcvComponent} from './hcv/hcv.component';
import {MlsComponent} from './mls/mls.component';
import {OlsComponent} from './ols/ols.component';
import {RbgComponent} from './rbg/rbg.component';
import {VcvComponent} from './vcv/vcv.component';
import {HdsComponent} from './hds/hds.component';
import {BotComponent} from './bot/bot.component';
import { PortalrobotComponent } from './portalrobot/portalrobot.component';

const routes: Routes = [

    {path: 'ols/:id', component: OlsComponent},
    {path: 'mls/:id', component: MlsComponent},
    {path: 'fts/:id', component: FtsComponent},
    {path: 'rbg/:id', component: RbgComponent},
    {path: 'vcv/:id', component: VcvComponent},
    {path: 'hds/:id', component: HdsComponent},
    {path: 'hcv/:id', component: HcvComponent},
    {path: 'bot/:id', component: BotComponent},
    {path: 'prtlrbt/:id', component: PortalrobotComponent},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SilverRoutingModule
{
}
